import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';

const ExportExcel = ({excelData, filename,title,color}) => {
    // const ws = XLSX.utils.json_to_sheet(excelData)
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const exportToExcel=async()=>{
        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = {Sheets: {'data':ws}, SheetNames: ['data']};
        const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, filename + fileExtension);
    }


    return (
        <button type="button" class={`btn ${color}  mx-1`} onClick={(e)=>exportToExcel(filename)}>
            <i class="bi bi-star me-1"></i> {title}
        </button>
    );
}

export default ExportExcel;